import React from "react";
import { NavLink } from "react-router-dom";

export default function ButtonCestParIci(props) {
  // Combine props.buttonClass with an additional class, e.g., "extra-class"
  const combinedClass = `${
    props.buttonClass || ""
  } btn-decoration d-flex justify-content-center`.trim();

  return (
    <NavLink
      to={props.lienCestParIci}
      target={props.buttonTarget}
      className={combinedClass}
    >
      {/* <div className="submit-btn text-center">{props.buttonText}</div> */}
      <div className="animate-btn">
        <div className="text-center z-3 btn-text">C'est par ici</div>
      </div>
    </NavLink>

    // <NavLink to={props.lienCestParIci}>
    //   <div className="submit-btn text-center mt-1">C'est par ici...</div>
    // </NavLink>
  );
}
